import { DateComparator, FieldType, CompleteRequirement } from '../../../types';
import { isUsingInBetweenComparator } from '../../../utils/inBetweenComparatorHelpers';

type SearchCombo = Pick<CompleteRequirement, 'searchCombo'>['searchCombo'];

/**
 * Transforms a requirement's conditions with BETWEEN comparator into separate IS_AFTER and IS_BEFORE conditions
 * This transformation is applied to requirements and processes their searchQueries array
 */
export const transformInBetweenDates = <Requirement extends Record<string, unknown>>(
  requirement: Requirement,
): Requirement => {
  if ('searchCombo' in requirement) {
    const { searchCombo: pretypedSearchCombo } = requirement;
    const searchCombo = pretypedSearchCombo as SearchCombo;
    const searchQueries = searchCombo.searchQueries;
    const transformedSearchQueries = searchQueries.flatMap((condition: any) => {
      if (
        condition.fieldType === FieldType.DATE &&
        isUsingInBetweenComparator(condition.comparatorType as any)
      ) {
        const value = 'value' in condition ? condition.value : { startDate: null, endDate: null };
        const { startDate, endDate } = value as {
          startDate: string | null;
          endDate: string | null;
        };

        // Return an array of two conditions: IS_AFTER and IS_BEFORE
        return [
          {
            ...condition,
            value: startDate,
            comparatorType: DateComparator.IS_AFTER,
          },
          {
            ...condition,
            value: endDate,
            comparatorType: DateComparator.IS_BEFORE,
          },
        ];
      }

      // Return the condition as-is if it's not a BETWEEN date condition
      return [condition];
    });

    return {
      ...requirement,
      searchCombo: {
        ...searchCombo,
        searchQueries: transformedSearchQueries,
      },
    };
  } else {
    return requirement;
  }
};
